<script setup lang="ts">
import type { AnimationItem, RendererType } from 'lottie-web'
import lottie from 'lottie-web'
import { markRaw, onBeforeUnmount, onMounted, shallowRef, useTemplateRef, watch } from 'vue'

type LottieAnimationData = Record<string, unknown>

const props = withDefaults(defineProps<{
  animationData: LottieAnimationData
  autoplay?: boolean
  loop?: boolean
  renderer?: RendererType
}>(), {
  autoplay: true,
  loop: true,
  renderer: 'svg'
})

const container = useTemplateRef<HTMLDivElement>('container')
const animation = shallowRef<AnimationItem | null>(null)

function destroyAnimation (): void {
  animation.value?.destroy()
  animation.value = null
}

function loadAnimation (): void {
  if (!container.value) return

  destroyAnimation()
  animation.value = markRaw(lottie.loadAnimation({
    animationData: props.animationData,
    autoplay: props.autoplay,
    container: container.value,
    loop: props.loop,
    renderer: props.renderer
  }))
}

onMounted(loadAnimation)

watch(() => props.animationData, loadAnimation)

onBeforeUnmount(destroyAnimation)
</script>

<template>
  <div
    ref="container"
    class="lottie-animation"
    aria-hidden="true"
  />
</template>

<style lang="scss" scoped>
.lottie-animation {
  width: 100%;
  height: 100%;
}
</style>
